import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class ComponentsNameParser implements Parser {
	parse(schema: Record<string, Schema.Component>) {
		const names = Object.keys(schema).map((name) => `"${name}"`);

		return names.length ? `export type Components = ${names.join("|")}` : "";
	}
}
